import { StyleSheet } from "react-native";
import Colors from "./Color";

const GlobalStyles = StyleSheet.create({
  container: {
    flex: 1,
    // justifyContent: "center",
    // alignItems: "center",
    backgroundColor: Colors.backgroundColor,
  },
  rowTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  rowSubText: {
    fontSize: 13,
    fontWeight: "regular",
    marginRight: 16,
    color: Colors.grayColor,
  },
  rowIcon: {
    marginRight: 4,
  },
  rowItem: {},
  rowThreeDots: {
    fontSize: 22,
    color: Colors.blackColor,
    paddingLeft: 16,
  },
  prova: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
    // paddingTop: 60,
    backgroundColor: Colors.backgroundColor,
  },
  scrollViewContent: {
    justifyContent: "center",
    // alignItems: "center",
    // paddingBottom: 60,
  },
  HStack: {
    flexDirection: "row",
    alignItems: "center",
  },
  Spacer: {
    flex: 1,
  },
  calendarRow: {
    flexDirection: "row",
    alignItems: "center",
    overflow: "hidden",
    backfaceVisibility: "hidden",
  },
  touchableRow: {
    backgroundColor: "white",
    borderRadius: 12,
    borderColor: Colors.borderColor,
    borderWidth: 0.1,
    paddingHorizontal: 14,
    height: 70,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  rowContainer: {
    flexDirection: "row",
    flex: 1,
    // justifyContent: "space-between",
    alignItems: "center",
    // padding: 10,
    paddingLeft: 15, // Increased horizontal padding for better spacing
    paddingRight: 15,
    backgroundColor: "white",
    marginBottom: 10,
    marginLeft: 10, // Added horizontal margins to give spacing from the sides of the view
    marginRight: 10,
    shadowColor: "#000",
    borderRadius: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4, // for Android shadow
  },
  optionsIcon: {
    fontSize: 24,
    color: "#888",
  },
  circle: {
    width: 10,
    height: 10,
    borderRadius: 50, // Half of the width/height
  },
  bubbleButton: {
    padding: 10,
    backgroundColor: "#007BFF",
    borderRadius: 10,
    alignItems: "center",
    marginBottom: 20,
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalView: {
    width: 300,
    padding: 24,
    maxWidth: 580,
    alignSelf: "center",
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    justifyContent: "space-between",
  },
  touchableBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    // height: 10000,
    backgroundColor: "rgba(15, 15, 15, 0.2)",
  },
  textInputStyle: {
    width: "100%",
    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    // backgroundColor: "rgba(0, 0, 0, 0.03)",
    color: Colors.blackColor,
    borderWidth: 0.1,
    marginTop: 16,
    padding: 10,
    borderRadius: 10,
    outlineStyle: "none",
  },
  menu: {
    // marginVertical: 15,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.borderColor,
  },
  Card: {
    backgroundColor: Colors.whiteColor,
    borderRadius: 14,
    padding: 18,
    borderWidth: 0.1,
    borderColor: Colors.borderColor,
  },
  CardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 14,
  },
  CardHeaderMain: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  CardIcon: {
    backgroundColor: Colors.lightGrayColor,
    padding: 6,
    borderRadius: 10,
  },
  SummaryCardIcon: {
    padding: 7,
    borderRadius: 11,
  },
  CardTitle: {
    fontSize: 12,
    fontWeight: "600",
    letterSpacing: 0.5,
    color: Colors.grayColor,
  },
});

export default GlobalStyles;
